/**
 * 外链 referrer 判断：排除站内域与字面量 IP。
 */
import { INTERNAL_REFERRER_HOST_SUFFIXES } from './constants';

const IPV4_HOSTNAME_PATTERN = /^(?:\d{1,3}\.){3}\d{1,3}$/;

/** 判断 hostname 是否为字面量 IP（IPv4 或含冒号的 IPv6） */
export const isLiteralIpHostname = (hostname: string): boolean => {
  const host = hostname.trim().toLowerCase();
  if (!host) {
    return false;
  }
  if (host.includes(':')) {
    return true;
  }
  return IPV4_HOSTNAME_PATTERN.test(host);
};

/**
 * 判断 hostname 是否为站内来源。
 * 站内 referrer 不触发归因写入。
 */
export const isInternalReferrerHostname = (hostname: string): boolean => {
  const host = hostname.trim().toLowerCase();
  if (!host) {
    return true;
  }
  if (isLiteralIpHostname(host)) {
    return true;
  }
  return INTERNAL_REFERRER_HOST_SUFFIXES.some(suffix => host === suffix || host.endsWith(`.${suffix}`));
};

/**
 * 判断 referrer 是否为有效广告外链来源。
 * 用于 shouldCaptureAttributedEntry 与 shouldReconcileReferrerSnapshot。
 */
export const isAttributedEntryReferrer = (referrer: string): boolean => {
  const trimmed = referrer.trim();
  if (!trimmed) {
    return false;
  }
  try {
    const host = new URL(trimmed).hostname;
    return !isInternalReferrerHostname(host);
  } catch {
    return false;
  }
};
